// extracted by mini-css-extract-plugin
module.exports = {"short":"juV-Q","fullWrapper":"hCUWX","shown":"Hp67Q","full":"aFwc7","link":"Swwx5"};